import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/storage'

// firebase init
const firebaseConfig = {
  apiKey: "AIzaSyBzz2wrhC-pU0rUFY6axX5F8c3s8Z9rONo",
  authDomain: "pmcsx-dc250.firebaseapp.com",
  databaseURL: "https://pmcsx-dc250.firebaseio.com",
  projectId: "pmcsx-dc250",
  storageBucket: "pmcsx-dc250.appspot.com",
  messagingSenderId: "633795030041",
  appId: "1:633795030041:web:872eb27bb177a42c55ce88",
  measurementId: "G-RRH8VNVMNX"
};
firebase.initializeApp(firebaseConfig)

// utils
const fb_db = firebase.firestore()
const fb_auth = firebase.auth()
const fb_storage = firebase.storage().ref()


// collection references
const fb_users = fb_db.collection('users')
const fb_bump = fb_db.collection('admins')
const fb_survey = fb_db.collection('survey')
const fb_faults = fb_db.collection('faults')
const fb_dispatch = fb_db.collection('dispatch')

// export utils/refs
export {
  fb_db,
  fb_auth,
  fb_storage,
  fb_users,
  fb_bump,
  fb_survey,
  fb_faults,
  fb_dispatch
}
